import React, { useEffect, useRef } from 'react';

interface EzoicAdProps {
  placementId: number;
  style?: React.CSSProperties;
  className?: string;
}

const debugLog = (value: any): void => console.log(value);

const EzoicAd: React.FC<EzoicAdProps> = ({
  placementId,
  style,
  className,
}) => {
  const adRef = useRef<HTMLDivElement>(null);
  const isAdShown = useRef(false);

  useEffect(() => {
    // Show ad when component mounts and Ezoic is loaded
    if (!isAdShown.current && window.ezstandalone && window.ezstandalone.cmd) {
      debugLog(`Showing Ezoic ad - placement: ${placementId}`);
      
      window.ezstandalone.cmd.push(() => {
        try {
          window.ezstandalone.showAds(placementId);
          isAdShown.current = true;
          debugLog(`✅ Ezoic ad shown for placement: ${placementId}`);
        } catch (error) {
          console.error(`❌ Ezoic error for placement ${placementId}:`, error);
        }
      });
    }

    // Cleanup: destroy placeholder when component unmounts
    return () => {
      if (isAdShown.current && window.ezstandalone && window.ezstandalone.destroyPlaceholders) {
        debugLog(`Destroying Ezoic ad - placement: ${placementId}`);
        
        window.ezstandalone.cmd.push(() => {
          try {
            window.ezstandalone.destroyPlaceholders(placementId);
            debugLog(`✅ Ezoic ad destroyed for placement: ${placementId}`);
          } catch (error) {
            console.error(`❌ Error destroying Ezoic placement ${placementId}:`, error);
          }
        });
        
        isAdShown.current = false;
      }
    };
  }, [placementId]);

  return (
    <div className={className} style={style} ref={adRef}>
      <div id={`ezoic-pub-ad-placeholder-${placementId}`}></div>
    </div>
  );
};

export default EzoicAd;
